import { render, staticRenderFns } from "./mode3.vue?vue&type=template&id=63b3098f&scoped=true"
import script from "./mode3.vue?vue&type=script&lang=js"
export * from "./mode3.vue?vue&type=script&lang=js"
import style0 from "./mode3.vue?vue&type=style&index=0&id=63b3098f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b3098f",
  null
  
)

export default component.exports